import { Profile } from './profile.model';

export class User {

    id: number;
    fiscalCode: string;
    name: string;
    surname: string;
    email: string;
    telephone: string;
    lastAccess: Date;
    activeProfile: any;
    profiles: Profile[];
    entityId: number;
    entityDescription: string;

    constructor(user: any = {}) {
        this.id = user.idUtente;
        this.fiscalCode = user.fiscalCode;
        this.name = user.name;
        this.surname = user.surname;
        this.email = user.email;
        this.telephone = user.telephone;
        this.lastAccess = user.lastAccess;
        this.activeProfile = user.activeProfile ? new Profile(user.activeProfile) : null;
        this.profiles = user.profiles ? user.profiles.map((profile) => new Profile(profile)) : [];
        this.entityId = user.entityId;
        this.entityDescription = user.entityDescription;
    }

}